import BasketItem from "./BasketItem"

export default function Basket (props) {
  const { order,
    handleShowBasket = Function.prototype,
    removeFromBasket = Function.prototype,
    incQuantity = Function.prototype,
    decQuantity = Function.prototype
  } = props

  const totalPrice = order.reduce((sum, el) => {
    return sum + el.regularPrice * el.quantity
  }, 0)
  return (
    <ul className="collection basket-collection">
      <li className="collection-item active">Корзина</li>
      {order.length ? order.map((item) => {
        return <BasketItem key={item.mainID} {...item}
          removeFromBasket={removeFromBasket}
          incQuantity={incQuantity}
          decQuantity={decQuantity}
        />
      }) :
        (<li className="collection-item">Корзина пуста</li>)}
      <li className="collection-item active">Общая стоимость: {totalPrice} руб.</li>
      <i className="material-icons close-btn" onClick={handleShowBasket}>close</i>
    </ul>
  )
}